export default __webpack_public_path__ + "static/media/icon_about.1ef31532.svg";